import EditDefault from '../../svg/defaultIcons/EditDefault'
import EditBoxy from '../../svg/boxyIcons/EditBoxy'
import EditModern from '../../svg/modernIcons/EditModern'
import editDefault from '../../svg/defaultIcons/EditDefault'

const EditIcon = ({ className }) => {
  const iconSelect = localStorage.getItem('iconsSelect')
  const rootClassName = `edit-icon-root ${className || ''}`

  const renderIcon = IconComponent => (
    <>
      <style>{'.edit-icon-root { display: flex; height: 25px; width: 25px; }'}</style>
      <IconComponent className={rootClassName} />
    </>
  )

  switch (iconSelect) {
    case 'Custom':
      return (
        <div>
          <img src={editDefault} alt='Edit' />
        </div>
      )
    case 'Boxy':
      return renderIcon(EditBoxy)
    case 'Modern':
      return renderIcon(EditModern)
    default:
      return renderIcon(EditDefault)
  }
}

export default EditIcon
